import { MakeswiftPageSnapshot } from '@makeswift/runtime/dist/types/next'

import { getNoIndexValueFromPath } from './validateIndexing'

type Props = {
	snapshot: MakeswiftPageSnapshot
	url: URL | null
}

export function getNoIndexValueFromMakeSwift({ snapshot, url }: Props) {
	const noIndex =
		snapshot.document.localizedPages.at(0)?.seo.isIndexingBlocked ??
		snapshot.document.seo.isIndexingBlocked ??
		getNoIndexValueFromPath(url?.pathname)

	return noIndex
}
